import { gql } from '@apollo/client';

export type {
  GetProductEligibility as IGetProductEligibility,
  GetProductEligibilityVariables as IGetProductEligibilityVariables,
} from './__generated__/GetProductEligibility';

export const GET_PRODUCT_ELIGIBILITY = gql`
  query GetProductEligibility($addressInput: AddressInput!) {
    address(address: $addressInput) {
      products {
        homeSell {
          isEligible
          valueEstimate {
            upper
            lower
            source
          }
          denialExplanation
          referral {
            url
          }
        }
      }
    }
  }
`;
